<template>
    <v-container>
        <div v-if="loadMask == true" id="cargando" wire:loading
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-card>
            <v-card-title class="justify-center primary" icon @click="mostrar()" style="cursor: pointer;">
                <v-toolbar-title id="titulocard">Videos</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon :color="'#FFFFFF'">{{ show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-card-title>
            <v-expand-transition>
                <div v-if="show">
                    <v-card-text style="margin-bottom: 4%;">
                        <v-row class="mt-1">
                            <v-col cols="12" md="6" sm="6" class="boton_Agregar">
                                <v-btn v-if="adjuntarArchivos == 1" tile @click="AdjuntarVideo" color="success">
                                    <v-icon left>
                                        mdi-plus
                                    </v-icon>
                                    Agregar Video
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <DataTable :url="urlListado" :columns="columns" :formatterActions="formatterActions"
                                    :params="displayInputs" :order="[]" @apiDT="apiDT = $event" :movil="isMovil"
                                    @Cancelar="CancelarShow"></DataTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <div v-show="showLightbox">
                        <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false" />
                    </div>
                    <v-overlay :value="overlay">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                    <v-row justify="center">



                        <v-dialog v-model="share" scrollable persistent content-class="dialogShareClass"
                            transition="dialog-bottom-transition">
                            <template>
                                <v-card>
                                    <v-card-title class="justify-center primary">
                                        <v-toolbar-title id="titulocard">Compartir Video</v-toolbar-title>
                                    </v-card-title>
                                    <v-progress-linear color="green accent-4" indeterminate rounded height="6"
                                        v-if="cargarModal"></v-progress-linear>
                                    <v-card-text>
                                        <v-row>
                                            <v-col cols="12" col-md="8" class="text-center">
                                                <span style="margin-bottom: 10%;">Selecciona un usuario para compartir y el
                                                    tiempo deseado</span>
                                                <br />
                                                <span class="files-report-label-style">Usuarios:</span>
                                                <multiselect v-model="usuarios.usid" class="centerInputs"
                                                    deselect-label="Remover el valor seleccionado"
                                                    selected-label="Seleccionado" select-label="Seleccione el usuario"
                                                    track-by="uslogin" label="usnom" :searchable="true" :max-height="150"
                                                    :multiple="true" placeholder="Seleccione una opción"
                                                    :options="usuarios.usuariosArray" :allow-empty="true" @input="onSelect">
                                                </multiselect>
                                                <span class="files-report-label-style">Fecha:</span>
                                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                                    transition="scale-transition" offset-y max-width="290px"
                                                    min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="dateFormatted" class="centerInputs" outlined
                                                            readonly v-bind="attrs" @blur="date = dateFormatted" v-on="on"
                                                            style="margin-top: 2%;"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="dateFormatted" locale="es-mx" :max="maxfecha"
                                                        :min="minDate" @input="menu1 = false">
                                                    </v-date-picker>
                                                </v-menu>
                                            </v-col>
                                            <v-col class="text-center">
                                                <span style="color: red;" v-if="spanModal"> Debe seleccionar un
                                                    usuario</span>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <v-card-actions class="justify-center">
                                        <v-btn color="primary" @click="CompartirVideo(usuarios.usid)"
                                            :disabled="buttonCompartir">
                                            Compartir
                                        </v-btn>
                                        <v-btn color="error" :disabled="buttonCompartir" variant="text"
                                            @click="CerrarModal()">Cancelar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>

                        <v-dialog v-model="info" scrollable persistent content-class="dialoginfoClass"
                            transition="dialog-bottom-transition">
                            <template>
                                <v-card>
                                    <v-card-title class="justify-center primary">
                                        <v-toolbar-title id="titulocard">Información Video</v-toolbar-title>
                                    </v-card-title>
                                    <v-progress-linear color="green accent-4" indeterminate rounded height="6"
                                        v-if="cargarModal"></v-progress-linear>
                                    <v-card-text v-if="loadInfo" class="mx-auto cardMovil">



                                        <v-container class="justify-center text-center" color="#FF00FF"
                                            v-if="infoEmpty == true">

                                            <span class="type-label-style">No se encontraron datos
                                                para este video</span>


                                        </v-container>

                                        <v-list v-if="infoEmpty == false" subheader three-line>
                                            <v-subheader v-if="loadInfo" class="text-sup justify-center text-center"
                                                inset>Usuarios
                                                previamente compartidos</v-subheader>

                                            <v-list-item v-for="(item) in infoData" :key="item.vcid">
                                                <v-list-item-avatar>
                                                    <v-icon class="blue lighten-1" dark>
                                                        mdi-account-multiple
                                                    </v-icon>
                                                </v-list-item-avatar>

                                                <v-list-item-content>

                                                    <strong><span style="font-size:16px">{{ item.destino }} </span></strong>

                                                    <v-list-item-subtitle>Expira: {{ item.expira }}</v-list-item-subtitle>

                                                    <v-list-item-subtitle class="text-subtitle">
                                                        Compartió:
                                                        {{ item.origen }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>

                                                <v-list-item-action>


                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">


                                                            <v-btn v-on="on" v-bind="attrs"
                                                                @click="EliminarPermiso(item.vcid)" color="red" icon>
                                                                <v-icon color="red lighten-1">mdi-close</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Eliminar permiso</span>
                                                    </v-tooltip>

                                                </v-list-item-action>

                                            </v-list-item>
                                        </v-list>

                                    </v-card-text>
                                    <v-card-actions class="justify-center">

                                        <v-btn color="error" :disabled="buttonCompartir" variant="text"
                                            @click="CerrarModalInfo()">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </template>
                        </v-dialog>

                    </v-row>
                </div>
            </v-expand-transition>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Archivos from '@/services/Archivos/Archivos.service.js';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import moment from "moment";
import DataTable from "@/components/pages/DataTableNet/DataTable";
import '@/components/pages/Visor/dist/vue-image-lightbox.min.css';
import LightBox from '@/components/pages/Visor/LightBox.vue';

export default {
    components: {
        DataTable,
        LightBox
    },
    data: function () {
        return {
            cargando: false,
            show: false,
            urlListado: 'Archivos/ObtenerVideos',
            apiDT: null,
            columns: [
                { name: 'doiniciales', data: 'doiniciales', title: 'Iniciales' },
                { name: 'dodescrip', data: 'dodescrip', title: 'Descripción' },
                { name: 'docalta', data: 'docalta', title: 'Fecha de subida' },
                { name: 'btnInfo', data: 'dodescrip', title: "", formatter: [this, "information"], orderable: false },
                { name: 'prclave', data: 'prclave', title: 'Usuario' },
                { name: "docid", data: "docid", title: "", formatter: [this, "verVideo"], orderable: false },
                { name: "ssdocid", data: "docid", title: "", formatter: [this, "compartir"], orderable: false },
                { name: "esdocid", data: "docid", title: "", formatter: [this, "eliminar"], orderable: false }

            ],
            displayInputs: {
                nrreporte: 0,
                svindice: 0,
            },
            formatterActions: [
                { click: [this, "VerVideoModal"] },
                { click: [this, "AbrirModalCompartir"] },
                { click: [this, "AbrirModalInfo"] },
                { click: [this, "EliminarVideo"] },
            ],
            usuarios: {
                usuariosArray: [],
                uslogin: '',
                usid: null,
                usnom: ''
            },
            datos: null,
            verarchi: false,
            loading: false,
            nombreArchivo: '',
            docid: 0,
            prefix: "tabla_",
            randomNum: Math.floor(Math.random() * 1000),
            percompartir: false,
            loaded: false,
            share: false,
            info: false,
            menu1: false,
            cargarModal: false,
            spanModal: false,
            minDate: null,
            maxfecha: null,
            dateFormatted: "",
            buttonCompartir: false,
            sourceVideo: '',
            loadMask: false,
            isMovil: true,
            infoData: null,
            infoEmpty: false,
            permisoEliminar: false,
            adjuntarArchivos: null,
            loadInfo: false,
            /****** */
            media: [{
                index: 0,
                src: '@/',
            }],
            showLightbox: false,
            overlay: false,
        }
    },
    props: [],
    computed: {
        ...mapState({ drawer: state => state.drawer }),
        ...mapState(['domain', 'informationPage']),
        DRAWER_STATE: {
            get() {
                return this.drawer
            },
        },
        tableName() {
            return this.prefix + this.randomNum;
        },
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte('reporte');
        await this.obtenerPermisos();
        await Archivos.EstatusReporte(this, this.datos);
        this.displayInputs = {
            nrreporte: this.datos.nrreporte,
            svindice: this.datos.svindice,
        };
        this.reloadTable();
        await this.obtenerEstadoReporte();
        moment.locale("en");
        let auxMinDate = moment().format("YYYY[-]MM[-]DD");
        this.Permisos();
        let auxDate = moment().add(15, 'd').format("YYYY[-]MM[-]DD");
        this.dateFormatted = auxDate;
        this.minDate = auxMinDate;

    },
    methods: {
        CancelarShow() {
            this.cargando = false;
        },
        verVideo(datos) {
            return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="0" data-params="${datos.docid}" title="Ver Video" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-play-circle-outline theme--dark"></i></span></button></div>` : ``;
        },
        compartir(datos) {
            if (this.percompartir) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="1" data-params="${datos.docid}" title="Compartir" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-share-variant theme--dark"></i></span></button></div>` : ``;
            }
            else {
                return ``;
            }
        },
        information(datos) {
            if (this.percompartir) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small teal dt-formatterAction" aria-haspopup="true" data-action="2" data-params="${datos.docid}" title="Ver información" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-account-multiple theme--dark"></i></span></button></div>` : ``;
            }
            else {
                return ``;
            }
        },
        eliminar(datos) {
            if (this.permisoEliminar) {
                return datos.docid ? `<div><button type="button" class="mr-1 v-btn v-btn--is-elevated v-btn--fab v-btn--has-bg v-btn--round theme--dark v-size--small secondary dt-formatterAction" aria-haspopup="true" data-action="3" data-params="${datos.docid}" title="Eliminar Archivo" aria-expanded="false"><span class="v-btn__content"><i aria-hidden="true" class="v-icon notranslate mdi mdi-delete theme--dark"></i></span></button></div>` : ``;
            } else {
                return ``;
            }
        },
        reloadTable() {
            if (this.apiDT != null) {
                this.apiDT.ajax.reload(null, false);
                this.apiDT.columns.adjust().responsive.recalc();
            }
        },

        mostrar() {
            if (this.show == true) {
                this.show = false;

            } else {
                this.show = true;
                this.cargando = false;

            }
        },
        async VerVideoModal(params, datos, fila) {
            this.overlay = true;
            var video = {
                index: 0,
                src: '@/'
            };
            this.media.push(video);
            this.media = this.media.filter(obj => obj.src == '@/');
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'Videos');
            formData.append("laaccion", "Vio Video");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", datos.docarchivo);
            formData.append("ladestinatario", "");
            await Archivos.AlmacenarVisitas(formData);
            var video = {
                caption: '<h4>' + datos.dodescrip + '</h4>',
                type: 'video',
                src: datos.rutaarchivo,
                paginas: 1
            };
            this.media.push(video);
            this.media = this.media.filter(obj => obj.src !== '@/');
            this.showLightbox = true;
            await this.$refs.lightbox.showImage(0);
            this.overlay = false;

        },
        AbrirModalCompartir(params, datos, fila) {

            this.idVideo = datos.docid;
            this.share = true;
            this.cargarModal = true;
            this.obtenerUsuarios().then(data => {

                this.cargarModal = false;
            })

            let auxDate = moment().add(15, 'd').format("YYYY[-]MM[-]DD");

            this.dateFormatted = auxDate;

        },
        async EliminarPermiso(vcid) {


            Archivos.EliminarPermiso(vcid).then(data => {

                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Correcto',
                    allowOutsideClick: false,
                    text: "Se ha eliminado el permiso",
                    showConfirmButton: true,
                    timer: 4500
                }).then(() => {
                    this.CerrarModalInfo();
                });
            })
        },
        AbrirModalInfo(params, datos, fila) {
            this.idVideo = datos.docid;
            this.infoEmpty = false;

            this.info = true;




            this.InfoCompartido(this.idVideo).then(data => {

                this.cargarModal = false;
            })
            //PG_Archivos_InfoCompartido
        },
        CerrarModalInfo() {
            this.info = false;

            this.infoData = null;
            this.spanModal = false;
            this.infoEmpty = false;
            this.loadInfo = false;
        },
        async InfoCompartido(idVideo) {
            this.infoData = await Archivos.ObtenerInfoVideo(idVideo);
            if (this.infoData.length < 1) {
                this.infoEmpty = true;
                this.loadInfo = true;
            }
            else {
                this.infoEmpty = false;
                this.loadInfo = true;
            }
        },
        async obtenerUsuarios() {
            if (this.usuarios.usuariosArray.length < 1) {
                let usuariosTemp = await Archivos.ObtenerUsuarios(this.datos);
                this.usuarios.usuariosArray = usuariosTemp;
            }
        },
        onSelect() {
            this.spanModal = false;
        },
        async Permisos() {
            await Archivos.ObtenerPermiso(this.datos).then(response => {
                if (response.length > 0) {
                    this.percompartir = true;
                }
            });
        },
        CerrarModal() {
            this.usuarios.usid = null;
            this.share = false;
            this.spanModal = false;
        },
        async CompartirVideo(usuario) {

            var usuariosString = '';

            if (this.usuarios.usid == null || this.usuarios.usid == 0) {
                this.spanModal = true;
                return;
            }



            usuario.forEach(async (usuarioFor, index) => {

                usuariosString = usuariosString += usuarioFor.uslogin + ',';

            });



            this.loadMask = true;
            this.CerrarModal();
            Archivos.CompartirVideo(this.datos, usuariosString, this.dateFormatted, this.idVideo).then(data => {



                this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Correcto',
                    allowOutsideClick: false,
                    text: "Se ha compartido el video",
                    showConfirmButton: true,
                    timer: 4500
                }).then(() => {
                    this.loadMask = false;
                });
            })


        },
        async obtenerPermisos() {
            let response = await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '51');
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 51)//Permiso Eliminar
                        this.permisoEliminar = true;
                });
            }

        },
        EliminarVideo(params, datos, fila) {

            this.$swal({
                position: "center",
                icon: "info",
                text: "¿Está seguro que desea eliminar este archivo?",
                showCancelButton: true,
                confirmButtonColor: '#536DFE',
                cancelButtonColor: '#FF5C93',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$swal({
                        title: 'Eliminando archivo, espere, por favor.',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: async () => {
                            this.$swal.showLoading();
                            let resp = await Archivos.EliminarVideo(this.datos, datos.docid, datos.rutaarchivo);

                            if (resp.error == false) {
                                var datosReporte = new FormData();
                                datosReporte.append("nrreporte", this.datos.nrreporte);
                                datosReporte.append("svindice", this.datos.svindice);
                                var formData = new FormData();
                                formData.append("lasitio", 'Prusia+');
                                formData.append("lomodulo", "Videos");
                                formData.append("laaccion", "Eliminó Video");
                                formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
                                formData.append("lanombre", datos.docarchivo);
                                formData.append("ladestinatario", "");
                                Archivos.AlmacenarVisitas(formData);
                                this.$swal({
                                    position: 'center',
                                    icon: 'success',
                                    title: 'Éxito',
                                    text: resp.msg,
                                    showConfirmButton: true,
                                    confirmButtonColor: '#536DFE',
                                    confirmButtonText: 'Aceptar',
                                    allowOutsideClick: false,
                                    timer: 4500,
                                }).then(async () => {
                                    this.reloadTable();
                                });

                            } else {
                                this.$swal({
                                    position: 'center',
                                    icon: 'warning',
                                    title: 'Error',
                                    text: resp.msg,
                                    showConfirmButton: false,
                                    timer: 2500
                                });
                            }
                        },
                    });
                }
            });
        },
        async obtenerEstadoReporte() {
            await Archivos.EstatusReporte(this, this.datos);
        },
        async AdjuntarVideo() {
            let asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
            this.$router.push({ path: asistenciaurl + '/Archivos/AdjuntarVideo' });

            //switch (this.datos.aiclave.toString()) {
            //    case "1":
            //        this.$router.push({ name: `AdjuntarVideoExpJur` });
            //        break;
            //    case "24":
            //        this.$router.push({ name: `AdjuntarVideoRobo` });
            //        break;
            //    case "23":
            //        this.$router.push({ name: `AdjuntarVideoRLV` });
            //        break;
            //    case "5":
            //        this.$router.push({ name: `AdjuntarVideoRCM` });
            //        break;
            //}
        }
    },

}

</script>
<style>
.v-data-table-header {
    font-weight: bold;
    background-color: success;
}

.text-sup {
    font-family: Poppins, sans-serif;
    font-size: 1.1em;
}

#titulocard {
    color: white;
}

.boton_NC {
    display: flex;
    justify-content: center;
}

@media screen and (min-width: 600px) {
    .boton_NC {
        display: flex;
        justify-content: end;
    }

    .boton_Agregar {
        display: flex;
        justify-content: start;
    }
}

@media screen and (max-width: 599px) {
    .boton_NC {
        display: flex;
        justify-content: center;
    }

    .boton_Agregar {
        display: flex;
        justify-content: center;
    }
}



.centerInputs {
    margin-top: 2% !important;
    width: 90% !important;
    display: block !important;
    margin-right: auto !important;
    margin-left: auto !important;
    margin-bottom: 3% !important;

}

.dialogClass {
    width: 65% !important;
}

.dialogShareClass {
    width: 30% !important;
}

.dialoginfoClass {
    width: 30% !important;
    max-height: 60% !important;
}

inputShare {
    width: 80% !important;
    justify-content: center;
    align-items: baseline;
}


@media screen and (max-width: 1200px) {


    .dialogClass {
        width: 75% !important;
    }

    .dialogShareClass {
        width: 75% !important;
    }

    .dialoginfoClass {
        width: 75% !important;
        max-height: 60% !important;
    }
}



@media screen and (max-width: 767px) {
    .select-registros {
        display: flex;
        justify-content: center;
        align-items: baseline;
    }

    .centerInputs {
        margin-top: 2% !important;
        width: 90% !important;
        display: block !important;
        margin-right: auto !important;
        margin-left: auto !important;
        margin-bottom: 3% !important;
    }

    .div-paginacion {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .dialogClass {
        width: 80% !important;
    }

    .dialogShareClass {
        width: 90% !important;
    }

    .dialoginfoClass {
        width: 90% !important;
        max-height: 70% !important;
    }
}


@media screen and (max-width: 500px) {

    .dialoginfoClass {
        width: 100% !important;
        max-width: 100% !important;
        max-height: 70% !important;
    }

    .cardMovil {
        padding: 0px !important;
        margin: 0px !important;
    }

    .dialogClass {
        width: 100% !important;
        max-width: 100% !important;
    }

    .dialogShareClass {
        width: 100% !important;
    }

    .centerInputs {
        margin-top: 2% !important;
        width: 100% !important;
        display: block !important;
        margin-right: auto !important;
        margin-left: auto !important;
        margin-bottom: 3% !important;
    }
}
</style>